import { Profile } from "../components/Sections/Profile";
import { Payments } from "../components/Sections/Payments";
import { Addresses } from "../components/Sections/Addresses";
import { PageHeading } from "../components/Headings/PageHeading";
import { useGetUserAddresses, useListPaymentMethods } from "../api/hooks/";
import { DashboardPageLayout } from "../components/Layouts/DashboardPageLayout";
import { LoadingLayout } from "../components/Layouts/LoadingLayout";
import "react-toastify/dist/ReactToastify.css";

export function Settings() {
  const {
    isLoading: isGetUserAddressLoading,
    isError: isGetUserAddressError,
    data: addressData,
  } = useGetUserAddresses();

  const {
    isLoading: isListPaymentMethodsLoading,
    isError: isListPaymentMethodsError,
    data: paymentMethodData,
  } = useListPaymentMethods();

  const isLoading = isGetUserAddressLoading || isListPaymentMethodsLoading;
  const isError = isGetUserAddressError || isListPaymentMethodsError;

  if (isLoading) return <LoadingLayout />;
  if (isError) return <div>Oops, something went wrong...</div>;

  return (
    <DashboardPageLayout>
      <main className="px-4 py-16 sm:px-6 lg:px-8 lg:py-8">
        <div className="mx-auto max-w-4xl space-y-10 lg:max-w-none">
          <PageHeading title="Settings" withBreadcrumbs />

          <Profile />
          <Payments payments={paymentMethodData} />
          <Addresses addresses={addressData?.addresses} />
        </div>
      </main>
    </DashboardPageLayout>
  );
}